type KaivaIconProps = {
  size?: number;
  radius?: number;
  className?: string;
  ariaLabel?: string;
};

export function KaivaIcon({
  size = 26,
  radius = 0.22,
  className,
  ariaLabel = 'kaiva',
}: KaivaIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 256"
      role="img"
      aria-label={ariaLabel}
      className={className}
    >
      <rect width="256" height="256" rx={Math.round(256 * radius)} fill="#0F172A" />
      <text
        x="84"
        y="184"
        fontFamily="Geist, Inter, system-ui, -apple-system, sans-serif"
        fontSize="170"
        fontWeight="700"
        letterSpacing="-2"
        fill="#F4F1E8"
      >
        k
      </text>
      <circle cx="172" cy="170" r="15" fill="#EC5800" />
    </svg>
  );
}
